"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _paginationHooks = require("./paginationHooks");

var _Pagination = require("./Pagination.style");
/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */


var Pagination = function Pagination(_ref) {
  var data = _ref.data,
      currentPage = _ref.currentPage,
      siblings = _ref.siblings,
      itemsPerPage = _ref.itemsPerPage,
      onPageChange = _ref.onPageChange,
      onNext = _ref.onNext,
      onPrevious = _ref.onPrevious;
  // Make sure the received data is an array
  var dataLength = data && Array.isArray(data) ? data.length : [];
  var paginationRange = (0, _paginationHooks.usePagination)({
    currentPage: currentPage,
    dataLength: dataLength,
    siblings: siblings,
    itemsPerPage: itemsPerPage
  }); // Don't display the pagination when we have only one page

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  var isFirstPage = currentPage === 1;
  var lastPage = paginationRange[paginationRange.length - 1];
  var isLastPage = currentPage === lastPage;
  return /*#__PURE__*/_react.default.createElement(_Pagination.Nav, null, /*#__PURE__*/_react.default.createElement(_Pagination.List, null, !isFirstPage && /*#__PURE__*/_react.default.createElement(_Pagination.Prev, {
    to: "#",
    isFirstPage: isFirstPage,
    onClick: function onClick(e) {
      return onPrevious(e);
    }
  }, /*#__PURE__*/_react.default.createElement(_Pagination.PrevIcon, {
    name: "ChevronRight"
  })), paginationRange.map(function (pageNumber, index) {
    var isCurrentPage = pageNumber === currentPage;

    if (pageNumber === _paginationHooks.ellipsis) {
      // eslint-disable-next-line react/no-array-index-key
      return /*#__PURE__*/_react.default.createElement(_Pagination.Ellipsis, {
        key: index
      }, _paginationHooks.ellipsis);
    }

    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react.default.createElement("li", {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_Pagination.ListLink, {
        to: "#",
        isCurrentPage: isCurrentPage,
        onClick: function onClick(e) {
          return onPageChange(e, pageNumber);
        }
      }, pageNumber))
    );
  }), !isLastPage && /*#__PURE__*/_react.default.createElement(_Pagination.Next, {
    to: "#",
    isLastPage: isLastPage,
    onClick: function onClick(e) {
      return onNext(e, currentPage);
    }
  }, /*#__PURE__*/_react.default.createElement(_Pagination.NextIcon, {
    name: "ChevronRight"
  }))));
};

Pagination.propTypes = {
  data: _propTypes.default.arrayOf(Object),
  siblings: _propTypes.default.number,
  itemsPerPage: _propTypes.default.number,
  currentPage: _propTypes.default.number,
  onPageChange: _propTypes.default.func,
  onNext: _propTypes.default.func,
  onPrevious: _propTypes.default.func
};
Pagination.defaultProps = {
  data: [],
  siblings: 1,
  itemsPerPage: 12,
  currentPage: 1,
  onPageChange: function onPageChange() {},
  onNext: function onNext() {},
  onPrevious: function onPrevious() {}
};
var _default = Pagination;
exports.default = _default;